import styled, { css } from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import sidebarClosedBg from '../../../assets/images/sidebar-collapsed-bg.jpg';
import sidebarBg from '../../../assets/images/sidebar-full-bg.jpg';
import { DefaultIcon } from '../../../components/Icon';

export const sidebarClosedWidth = '90px';
export const sidebarOpenedWidth = '180px';
export const sidebarOpenedWidthLarge = '213px';
export const sidebarDeviceWidth = '257px';
const mobilePadding = '30px';

export const SidebarWrapperDiv = styled.div`
  ::-webkit-scrollbar {
    width: 0;
  }
  overflow-y: scroll;
  background-image: url(${sidebarBg});
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 110;
  width: ${sidebarDeviceWidth};
  ${props => props.theme.contentDropShadow};
  right: ${props =>
    props.sidebarOpenedDevice ? '0' : `calc(-${sidebarDeviceWidth} - 20px)`};
  transition: right 200ms ease-in;
  @media screen and (min-width: 1024px) {
    left: 0;
    right: auto;
    z-index: 11;
    ${props =>
      props.theme.sidebarOpened
        ? css`
            width: ${sidebarOpenedWidth};
            @media screen and (min-width: 1440px) {
              width: ${sidebarOpenedWidthLarge};
            }
          `
        : css`
            background-image: url(${sidebarClosedBg});
            width: ${sidebarClosedWidth};
          `}
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SidebarTopDiv = styled.div`
  height: 65px;
  text-align: center;
  @media screen and (min-width: 768px) {
    height: 75px;
  }
  @media screen and (min-width: 1024px) {
    height: 130px;
    ${props =>
      props.theme.sidebarOpened &&
      css`
        height: 170px;
      `}
  }
`;

export const SidebarLogoImg = styled.img`
  height: 24px;
  margin-top: 65px;
  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

export const CloseIconDiv = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  svg {
    fill: white;
    height: 1.6rem;
    width: 1.6rem;
  }
  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

export const SidebarSpacerDiv = styled.div`
  border-bottom: 1px solid white;
  margin: 18px ${mobilePadding};
  /* width: 180px; */
  @media screen and (min-width: 768px) {
    margin: 18px auto;
    width: 196px;
  }
  @media screen and (min-width: 1024px) {
    width: ${props => (props.theme.sidebarOpened ? '50px' : '34px')};
  }
  ${props =>
    props.desktopOnly &&
    css`
      @media screen and (max-width: 1023px) {
        display: none;
      }
    `}
`;

export const SidebarDeviceTopDiv = styled.div`
  @media screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

export const SidebarDeviceBottomDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LogoutButton = styled.button`
  ${props => props.theme.fontStackHeader}
  width: 100%;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 20px 0;
  display: block;
  border-top: 1px solid white;
  color: white;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    background-color: ${props => props.theme.indigo};
  }
`;

export const ToggleArrowDiv = styled.div`
  display: flex;
  width: 100%;
  height: 5rem;
  justify-content: center;
  align-items: center;
  svg {
    fill: white;
    height: 2.4rem;
    width: 2.4rem;
  }
  ${props =>
    props.theme.sidebarOpened &&
    css`
      justify-content: flex-end;
      padding-right: 1.5rem;
    `}
  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

const sidebarItemHoverEffect = css`
  h5 {
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    position: relative;
  }
  h5:before {
    content: '';
    position: absolute;
    z-index: -1;
    left: 51%;
    right: 51%;
    bottom: -5px;
    background: white;
    height: 2px;
    transition-property: left, right;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
  }
  &:hover h5:before,
  &:focus h5:before,
  &:active h5:before {
    left: 0;
    right: 0;
  }
`;

// SidebarItems
export const SidebarItemLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 63px;
  padding-left: ${mobilePadding};
  ${props =>
    props.active &&
    css`
      background-color: ${props => props.theme.indigo};
    `}

  h5 {
    color: white;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.6rem;
    @media screen and (min-width: 1024px) {
      ${props =>
        !props.theme.sidebarOpened &&
        css`
          display: none;
        `}
    }
  }
  @media screen and (min-width: 768px) {
    padding-left: 0;
    align-items: center;
    height: 125px;
    margin: 10px 0;
    ${props =>
      !props.theme.sidebarOpened &&
      css`
        height: 74px;
      `}
      ${props =>
        !props.active &&
        css`
          ${sidebarItemHoverEffect}
        `}
    /* &:not(.active) {
      ${sidebarItemHoverEffect}
    } */
    h5 {
      margin-top: 15px;
      max-width: 100px;
      text-align: center;
    }
  }
`;

export const SidebarSecondaryItemLink = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 58px;
  padding-left: ${mobilePadding};
  &.active {
    background-color: ${props => props.theme.indigo};
  }
  h5 {
    color: white;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.6rem;
    margin-left: 15px;
  }
  @media screen and (min-width: 768px) {
    padding-left: 65px;

    h5 {
      margin-left: 30px;
    }
  }
  svg {
    fill: white;
    height: 2rem;
    width: 2rem;
  }
`;

export const SidebarIcon = styled(DefaultIcon)`
  @media screen and (max-width: 767px) {
    display: none;
  }
  fill: white;
  height: 2.8rem;
  width: 2.8rem;

  ${props =>
    props.name === 'partners' &&
    css`
      height: 4rem;
      width: 4rem;
    `}
  ${props =>
    props.name === 'handMoney' &&
    css`
      height: 3.4rem;
      width: 3.4rem;
    `}
`;
